// extracted by mini-css-extract-plugin
module.exports = {"iframe-outer":"styles-m__iframe-outer__3hOCe","close-div":"styles-m__close-div__wM2h4","skeloton":"styles-m__skeloton__1ECW1","ac":"styles-m__ac__3NobS","ec":"styles-m__ec__2dkL-"};